<template>
  <div class="goods-detail-page" v-if="orderConfirmData">
    <van-nav-bar title="确认订单" left-arrow @click-left="$router.back()" fixed placeholder />

    <div class="order-details">
      <van-cell-group>
        <van-cell :title="orderConfirmData.shopName" :label="orderConfirmData.shopAddress" icon="location-o" />
      </van-cell-group>

      <div class="order-items">
        <div class="order-item" v-for="item in orderConfirmData.goodsInfo[0].items" :key="item.uniqueId">
          <!-- {{item}} -->
          <img :src="item.image" alt="" class="item-image" />
          <div class="item-info">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-specs">{{ formatPractice(item) }}</div>
          </div>
          <div class="item-price">
            <div class="count">￥{{ item.salePrice }}</div>
          </div>
        </div>
      </div>

      <!-- 优惠券选择 -->
      <van-cell-group>
        <van-cell title="优惠券" :value="couponDisplayText" is-link @click="showCouponPopup = true" />
      </van-cell-group>

      <van-cell-group title="订单备注">
        <van-field v-model="remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入备注"
          show-word-limit />
      </van-cell-group>
    </div>

    <van-submit-bar button-text="下单" @submit="onSubmit" :loading="submitting" />

    <!-- 优惠券弹窗 -->
    <van-popup v-model="showCouponPopup" position="bottom" round closeable :style="{ height: '60%' }">
      <div class="coupon-popup">
        <div class="popup-title">优惠券</div>
        <div class="coupon-list" v-if="couponList.length > 0">
          <div v-for="coupon in couponList" :key="coupon.cardId || coupon.couponRuleId" class="coupon-item" :class="{
            active: selectedCoupon && (selectedCoupon.cardId === coupon.cardId || selectedCoupon.couponRuleId === coupon.couponRuleId),
          }" @click="selectCoupon(coupon)">
            <div class="coupon-content">
              <div class="coupon-name">{{ coupon.couponName || coupon.title }}</div>
            </div>
            <div class="coupon-checkbox">
              <van-checkbox :value="selectedCoupon && (selectedCoupon.cardId === coupon.cardId || selectedCoupon.couponRuleId === coupon.couponRuleId)
                " @click.stop />
            </div>
          </div>
        </div>
        <div class="no-coupon" v-else>暂无可用优惠券</div>
        <div class="popup-footer">
          <van-button type="primary" block @click="confirmCouponSelection">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapState } from "vuex";
export default {
  name: "GoodsDetail",
  data() {
    return {
      orderInfo: null,
      orderConfirmData: null,
      orderKey: "",
      remark: "",
      showCouponPopup: false,
      couponList: [],
      selectedCoupon: null,
      submitting: false,
      gettingOrder: false,
    };
  },
  computed: {
    ...mapState(["appConfig", "uuid", "memberCoupon"]),
    couponDisplayText() {
      if (this.selectedCoupon) {
        return this.selectedCoupon.couponName || this.selectedCoupon.title || '优惠券';
      }
      if (this.couponList.length > 0) {
        return `${this.couponList.length}张可用`;
      }
      return "暂无可用";
    },
  },
  async created() {
    try {
      this.orderInfo = JSON.parse(this.$route.query.orderInfo);
      console.log('订单信息:', this.orderInfo);
      
      // 直接使用传入的数据
      this.orderConfirmData = this.orderInfo;
      console.log('订单数据:', this.orderConfirmData);
      
      // 从 Vuex 获取优惠券并默认选中
      if (this.$store.state.memberCoupon) {
        this.couponList = [this.$store.state.memberCoupon];
        this.selectedCoupon = this.$store.state.memberCoupon;
        console.log('已选中优惠券:', this.selectedCoupon);
      }
    } catch (error) {
      this.$toast("订单信息解析失败");
      console.error(error);
      // this.$router.back();
    }
  },
  methods: {
    getErrorMessage(error) {
      if (!error) return '请求失败';
      if (typeof error === 'string') return error;
      if (error.message) return error.message;
      if (error.response && error.response.data) {
        const data = error.response.data;
        if (typeof data === 'string') return data;
        return data.message || data.msg || JSON.stringify(data);
      }
      try { return String(error); } catch (_) { return '请求失败'; }
    },

    selectCoupon(coupon) {
      this.selectedCoupon = coupon;
    },
    confirmCouponSelection() {
      this.showCouponPopup = false;
    },
    async onSubmit() {
      if (this.submitting) return;
      this.submitting = true;

      try {
        await this.submitOrder();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
        this.$toast.fail(this.getErrorMessage(error) || '下单请求失败');
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
    // 蜜雪订单提交
    async submitOrder() {
      const cartData = this.orderConfirmData.cartData;
      
      // 从购物车数据中提取并简化 products 参数
      const products = (cartData.products || []).map(product => ({
        productId: product.productId,
        cupId: product.cupId || '',
        modifiedTime: product.productModifiedTime || product.modifiedTime,
        productAmount: product.productAmount || 1,
        specIds: product.specs ? product.specs.map(s => s.specId) : [],
        attributeIds: product.attrs ? product.attrs.map(a => a.attributeId) : [],
        comboProductDetail: product.comboProductDetail || []
      }));
      
      const response = await request.post("/mx/create-order", {
        shopId: this.$route.query.shopId,
        products: products,
        transToken: cartData.transToken || '',
        couponCode: this.selectedCoupon ? this.selectedCoupon.couponCode : '',
        remark: this.remark || '',
        accessToken: this.$store.state.mxAccessToken,
        uuid: this.uuid, // 添加 uuid 用于判断链接使用状态
        payChannel: this.$store.state.payChannel || 'wechat',
        miniProgType: this.$store.state.payChannel === 'alipay' ? 2 : 1,
      });

      console.log('下单响应:', response);

      if (response && response.code === 0 && response.data) {
        this.$toast.success('下单成功');
        const orderCode = response.data.orderCode;
        const isAlipay = this.$store.state.payChannel === 'alipay';
        // 支付宝：进订单详情待支付，点「去支付」再调预支付
        if (isAlipay) {
          this.$router.replace({
            path: '/order-detail',
            query: { orderCode },
          });
          return;
        }
        const finalPrice =
          response.data.finalPrice ||
          response.data.price ||
          response.data.payPrice ||
          '';
        await this.callOrderPrepay(orderCode, finalPrice);
      } else {
        this.$toast.fail(response.msg || '下单失败');
      }
    },
    
    // 微信无感预支付
    async callOrderPrepay(orderCode, finalPrice = '') {
      try {
        const prepayPayload = {
          orderCode: orderCode,
          payType: 1,
          accessToken: this.$store.state.mxAccessToken,
          payChannel: 'wechat',
        };
        if (finalPrice !== '' && finalPrice != null) {
          prepayPayload.finalPrice = finalPrice;
        }

        const prepayResponse = await request.post('/mx/order-prepay', prepayPayload);
        
        console.log('预支付响应:', prepayResponse);
        
        const isSuccess = prepayResponse && (prepayResponse.success || prepayResponse.code === 0);
        
        if (isSuccess) {
          this.$router.replace({
            path: '/order-detail',
            query: { orderCode: orderCode },
          });
        } else {
          this.$toast.fail(prepayResponse.message || prepayResponse.msg || '支付失败');
        }
      } catch (error) {
        console.error('预支付失败:', error);
        this.$toast.fail('支付失败');
      }
    },

    formatPractice(item) {
      // 现在从 skuInfo 中直接获取规格信息
      if (item.skuInfo) {
        return Object.values(item.skuInfo).join(" , ");
      }
      const specs = (item.orderItemSpecList || []).map(
        (spec) => spec.specValue
      );
      const practices = (item.practiceList || []).map((p) => p.value);
      return [...specs, ...practices].join(" , ");
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-detail-page {
  padding-bottom: 100px;
  background-color: #f7f8fa;
}

.order-details {
  margin-top: 12px;
}

.order-items {
  background-color: #fff;
  margin-bottom: 12px;
  padding: 0 12px;

  .order-item {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .item-image {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    margin-right: 12px;
  }

  .item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .item-name {
      font-size: 16px;
      font-weight: 500;
    }

    .item-specs {
      font-size: 12px;
      color: #969799;
      margin-top: 4px;
    }
  }

  .item-price {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .count {
      font-size: 14px;
      color: #969799;
    }
  }
}

.van-cell-group {
  margin-bottom: 12px;
}

.van-submit-bar {
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.04);
}

.coupon-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;

  .popup-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    padding: 16px;
    background-color: #fff;
    position: relative;
  }

  .coupon-list {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
  }

  .no-coupon {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
  }

  .coupon-item {
    display: flex;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 16px;
    position: relative;
    border: 1px solid #fff;
    align-items: center;

    &.active {
      border-color: #ee0a24;
    }
  }

  .coupon-content {
    flex: 1;

    .coupon-name {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }

    .coupon-info {
      display: none; // 隐藏详细信息
    }
  }

  .coupon-checkbox {
    margin-left: 12px;
  }

  .popup-footer {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #f5f5f5;

    .van-button {
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
    }
  }
}
</style>